import axios from 'axios'
import { OSS_DIR, OSS_DIR_NAME } from '@/constants/common'
import userApi from '@/apis/user'
import { randomString } from '@/utils/utils'
// import { OSS_ENV_URL } from '@/constants/url-env'

/**
 * 文件上传接口
 * @param {object} fileObj 文件对象
 * @param {string} directory 所属文件夹
 * @param {object} options 参数
 * @param {string} options.fileName 文件名
 * @param {string} options.prefix 文件名前缀
 * @param {function} options.onProgress 上传进度回调函数
 * @returns {Promise<any>} 操作后的promise回调
 */
export async function upload(fileObj, directory, options = {}) {
  if (!directory) {
    console.error('请指定文件夹')
  }
  const image = Object.keys(OSS_DIR).find((dir) => OSS_DIR[dir] === directory)
  if (import.meta.env.DEV && !image) {
    const keys = Object.keys(OSS_DIR)
      .map((key) => `OSS_DIR.${key}`)
      .join('、')
    throw new Error(`directory 属性必须为 ${keys} 其中一个`)
  }
  if (import.meta.env.DEV) {
    console.log(`上传至【${OSS_DIR_NAME[directory]}】文件夹`)
  }
  // 获取policy信息
  const res = await userApi.getUploadPolicy({ image })
  const { accessKeyId, dir, policy, signature, host } = res
  const getFileName = () => {
    const randomStringLength = 6
    const fileName = (options.fileName || fileObj.name).replaceAll(' ', '') // 文件名去空格
    const randomName = `${randomString(randomStringLength, 'mix', options.prefix || '')}_${new Date().getTime()}_${fileName}`
    // 要上传到后端返回的指定路径下，否则报无权限
    return `${dir}/${randomName}`
  }
  // const host = OSS_ENV_URL
  const fileName = getFileName()
  // 拼接文件上传请求
  const fileReq = new FormData()
  fileReq.append('key', fileName)
  fileReq.append('policy', policy)
  fileReq.append('OSSAccessKeyId', accessKeyId)
  fileReq.append('success_action_status', '200')
  fileReq.append('signature', signature)
  fileReq.append('file', fileObj)
  await axios.post(host, fileReq, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return `${host}/${encodeURIComponent(fileName)}`
}
